import { gql } from '@apollo/client';

// Authentication mutations
export const LOGIN_USER = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        id
        name
        email
        role
        tokenBalance
      }
    }
  }
`;

export const REGISTER_USER = gql`
  mutation Register($input: CreateUserInput!) {
    register(input: $input) {
      token
      user {
        id
        name
        email
        role
        tokenBalance
      }
    }
  }
`;

// Group mutations
export const JOIN_GROUP = gql`
  mutation JoinGroup($groupId: ID!) {
    joinGroup(groupId: $groupId) {
      id
      status
      currentSize
      participants {
        id
        name
      }
    }
  }
`;

export const CREATE_GROUP = gql`
  mutation CreateGroup($input: CreateGroupInput!) {
    createGroup(input: $input) {
      id
      name
      type
      status
      targetSize
      currentSize
    }
  }
`;

// Purchase mutations
export const CREATE_PURCHASE = gql`
  mutation CreatePurchase($input: CreatePurchaseInput!) {
    createPurchase(input: $input) {
      id
      status
      totalAmount
      savingsAmount
      paymentMethod
      createdAt
      products {
        product {
          id
          name
          images
        }
        quantity
        priceAtPurchase
        totalPrice
      }
    }
  }
`;

export const PROCESS_PAYMENT = gql`
  mutation ProcessPayment($input: ProcessPaymentInput!) {
    processPayment(input: $input) {
      success
      purchaseId
      transactionId
      message
    }
  }
`;

export const UPDATE_PURCHASE_STATUS = gql`
  mutation UpdatePurchaseStatus($purchaseId: ID!, $status: PurchaseStatus!) {
    updatePurchaseStatus(purchaseId: $purchaseId, status: $status) {
      id
      status
      updatedAt
    }
  }
`;

// Token and transaction mutations
export const TRANSFER_TOKENS = gql`
  mutation TransferTokens($input: TransferTokensInput!) {
    transferTokens(input: $input) {
      id
      from {
        id
        name
        tokenBalance
      }
      to {
        id
        name
        tokenBalance
      }
      amount
      type
      createdAt
    }
  }
`;

export const EARN_TOKENS = gql`
  mutation EarnTokens($input: EarnTokensInput!) {
    earnTokens(input: $input) {
      id
      amount
      source
      description
      createdAt
      user {
        id
        tokenBalance
      }
    }
  }
`;

// Cart mutations
export const ADD_TO_CART = gql`
  mutation AddToCart($input: AddToCartInput!) {
    addToCart(input: $input) {
      id
      items {
        product {
          id
          name
          currentPrice
          images
        }
        quantity
        totalPrice
      }
      totalAmount
    }
  }
`;

export const REMOVE_FROM_CART = gql`
  mutation RemoveFromCart($cartId: ID!, $productId: ID!) {
    removeFromCart(cartId: $cartId, productId: $productId) {
      id
      items {
        product {
          id
          name
          currentPrice
        }
        quantity
        totalPrice
      }
      totalAmount
    }
  }
`;

export const UPDATE_CART_QUANTITY = gql`
  mutation UpdateCartQuantity($input: UpdateCartQuantityInput!) {
    updateCartQuantity(input: $input) {
      id
      items {
        product {
          id
          name
          currentPrice
        }
        quantity
        totalPrice
      }
      totalAmount
    }
  }
`;

export const CLEAR_CART = gql`
  mutation ClearCart($cartId: ID!) {
    clearCart(cartId: $cartId) {
      id
      items {
        product {
          id
        }
        quantity
      }
      totalAmount
    }
  }
`;

// Resource and logistics mutations
export const CREATE_RESOURCE = gql`
  mutation CreateResource($input: CreateResourceInput!) {
    createResource(input: $input) {
      id
      title
      type
      status
      tokenValue
      description
    }
  }
`;

export const UPDATE_LOGISTICS = gql`
  mutation UpdateLogistics($input: UpdateLogisticsInput!) {
    updateLogistics(input: $input) {
      id
      type
      status
      scheduledTime
      assignedTo {
        id
        name
      }
    }
  }
`;


export const COMMIT_TO_GROUP_PURCHASE = gql`
  mutation CommitToGroupPurchase($input: CreateCommitmentInput!) {
    commitToGroupPurchase(input: $input) {
      commitment {
        id
        status
        committedAmount
        authorizedAmount
      }
      clientSecret
      authorizationAmount
      estimatedSavings
    }
  }
`;

// Product mutations
export const CREATE_PRODUCT = gql`
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      id
      name
      description
      category
      images
      basePrice
      currentPrice
      approvalStatus
      createdAt
    }
  }
`;

// Product update and delete mutations
export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($id: ID!, $input: UpdateProductInput!) {
    updateProduct(id: $id, input: $input) {
      id
      name
      description
      category
      images{
        full
        alt
      }
      basePrice
      currentPrice
      available
      approvalStatus
      updatedAt
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id) {
      success
      message
    }
  }
`;

export const TOGGLE_PRODUCT_AVAILABILITY = gql`
  mutation ToggleProductAvailability($id: ID!, $available: Boolean!) {
    toggleProductAvailability(id: $id, available: $available) {
      id
      available
    }
  }
`;
